export default (axios) => ({
    getHotDealProducts: (params) => axios.get('/b/hot_deals_product', { params }),
    getHotDealVouchers: (params) => axios.get('/b/hot_deals_voucher', { params }),
});
